import { MembershipApiItem } from 'types/membership'
import { MembershipClient, MembershipClientDTO } from 'types/membership-client'
import {
    patchApiRequest,
    postApiRequest,
    putApiRequest,
} from 'utils/fetch-helper'
import { convertMinsToHrsMins } from 'utils/string-localization-helper'

export async function createMembershipClient(dto: MembershipClientDTO) {
    const api_output = await postApiRequest(`/v1/memberships/clients`, dto)
    return api_output
}

export async function confirmMembershipPayment(
    tenant_id: string,
    client_id: string,
    membership_id: string,
    amount: number,
    location_id: string | undefined | null,
    fullyPaid?: boolean,
    payment_method?: string | undefined
) {
    const paymentMethod = payment_method
        ? payment_method
        : amount > 0
        ? 'CARD'
        : ''
    const dto = {
        amount,
        tenantId: tenant_id,
        membershipClient: {
            membershipId: membership_id,
        },
        order: {
            clientId: client_id,
            tenantId: tenant_id,
            type: 'MEMBERSHIP',
            paymentMethod: paymentMethod || undefined,
            fullyPaid: fullyPaid,
        },
        locationId: location_id,
    }

    const url = payment_method === 'CASH' || amount == 0
            ? '/v1/orders/order-membership' :
            `/v1/payments/confirm-membership-payment`
    const api_output = await postApiRequest(url, dto)
    return api_output
}

export async function updateMembershipClient(
    membership_client_id: string,
    dto: MembershipClientDTO
) {
    const api_output = await putApiRequest(
        `/v1/memberships/clients/${membership_client_id}`,
        dto
    )
    return api_output
}

export async function reactivateMembershipClient(
    membership_client_id: string,
    expiry_date: string
) {
    const api_output = await patchApiRequest(
        `/v1/memberships/clients/${membership_client_id}/uncancel?expiresAt=${expiry_date}&renewsAt=${expiry_date}`
    )
    return api_output
}

export async function cancelMembershipClient(membership_client_id: string) {
    const api_output = await patchApiRequest(
        `/v1/memberships/clients/${membership_client_id}/cancel`
    )
    return api_output
}

// TODO: AOT-1344
export function mapMembershipAndClientMembership(membership: MembershipApiItem, mc: MembershipClient) {
    mc.name = membership.name
    mc.status = mc.status.toLowerCase()
    mc.price = membership.price as number
    mc.amount = (
        membership.price + (membership.additionalFee || 0)
    ).toString()

    // mc.remaining = 100
    if (membership.redemptionAmount) {
        mc.remaining =
            parseFloat((membership.redemptionAmount - mc.usedAmount).toFixed(2))
        mc.redemption_type = 'Amount'
        mc.details = `${mc.remaining} of ${membership.redemptionAmount} amount left`
    } else if (membership.redemptionMinutes) {
        mc.remaining =
            membership.redemptionMinutes - mc.usedMinutes
        mc.redemption_type = 'Minutes'
        mc.details = `${convertMinsToHrsMins(
            mc.remaining
        )} of ${membership.redemptionMinutes / 60
            } hours left`
    } else if (membership.redemptionServices) {
        mc.remaining =
            membership.redemptionServices -
            mc.usedServiceCount
        mc.redemption_type = 'Services'
        mc.details = `${mc.remaining} of ${membership.redemptionServices} classes left`
    }

    if (membership.membershipPackage) {
        mc.type = 'package'
        mc.renewal = 'NONE'
        mc.validity = `${membership.membershipPackage.validityValue}-${membership.membershipPackage.validityType}`
        mc.renewal_or_expiry_date = new Date(mc.expiresAt)
    } else if (membership.membershipSubscription) {
        mc.type = 'subscription'
        if (mc.renewsAt) {
            mc.renewal_or_expiry_date = new Date(
                mc.renewsAt
            )
        } else {
            mc.renewal = 'NONE'
        }

        mc.validity = `${membership.membershipSubscription.timePeriod}`
        if (
            membership.membershipSubscription
                .numberOfCycles != -1
        ) {
            mc.validity += ` (${membership.membershipSubscription.numberOfCycles})`
        }
    }
}